var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74936 3.21928V11.3337H5.41603V3.21928L1.84002 6.79526L0.897217 5.85246L6.0827 0.666992L11.2681 5.85246L10.3253 6.79526L6.74936 3.21928Z",
    fill: "#fca5a5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrowUp);
export default __webpack_public_path__ + "static/media/red-arrow-up.02116e79795c47c5f40a5e6a764028ae.svg";
export { ForwardRef as ReactComponent };